"use client";

import { Suspense } from "react";

import useDistrictJobDetailsURLDrawer from "@/components/shared/jobs/district-job-details-drawer/use-district-job-details-url-drawer";
import useJobDetailsURLDrawer from "@/components/shared/jobs/job-details-drawer/use-job-details-url-drawer";

// Drawers that are available app-wide
function GlobalDrawersInner() {
  const { content: jobDetailsContent } = useJobDetailsURLDrawer();
  const { content: districtJobDetailsContent } =
    useDistrictJobDetailsURLDrawer();

  return (
    <>
      {jobDetailsContent}
      {districtJobDetailsContent}
    </>
  );
}

// Wrap this in Suspense to avoid the `useSearchParams` usage above
// from de-opting the whole app into client-side rendering
// See: https://nextjs.org/docs/messages/deopted-into-client-rendering
export default function GlobalDrawers() {
  return (
    <Suspense fallback={null}>
      <GlobalDrawersInner />
    </Suspense>
  );
}
